/**
 * content — «Контент»: тема + ключевые слова, затем релевантность / полнота
 * (missingInfo) / точность (issues). Зеркалит ContentSection.tsx: та же пара
 * видимость-флагов (hasTopics / hasContentAnalysis), тот же приоритет для
 * заголовочного балла (relevance ?? completeness ?? accuracy).
 */
import { card, kvRow, tag, scoreSpan } from '../primitives';
import { escapeHtml } from '../escape';
import type { SectionFn } from '../types';

function notesList(notes: string[] | undefined): string {
  if (!notes || notes.length === 0) return '';
  return `<ul>${notes.map((n) => `<li>${escapeHtml(n)}</li>`).join('')}</ul>`;
}

export const renderContent: SectionFn = (input, t) => {
  const { content } = input.analysis.result;
  const topic = content?.topic;
  const relevance = content?.relevance;
  const completeness = content?.completeness;
  const accuracy = content?.accuracy;

  const hasTopics = !!topic;
  const hasContentAnalysis = !!relevance || !!completeness || !!accuracy;
  if (!hasTopics && !hasContentAnalysis) return '';

  const topicHtml = hasTopics
    ? `<div class="blk">${
        topic!.mainTopic
          ? `<p style="font-weight:600;margin-bottom:6px">${escapeHtml(topic!.mainTopic)}</p>`
          : ''
      }${
        topic!.keywords && topic!.keywords.length > 0
          ? topic!.keywords.map((kw) => tag(kw)).join(' ')
          : ''
      }</div>`
    : '';

  const relevanceHtml = relevance
    ? kvRow(t('records.analysisPanel.content.relevance'), scoreSpan(relevance.score)) +
      notesList(relevance.feedback ? [relevance.feedback] : undefined)
    : '';

  const completenessHtml = completeness
    ? kvRow(
        t('records.analysisPanel.content.completeness'),
        scoreSpan(completeness.score)
      ) + notesList(completeness.missingInfo)
    : '';

  const accuracyHtml = accuracy
    ? kvRow(t('records.analysisPanel.content.accuracy'), scoreSpan(accuracy.score)) +
      notesList(accuracy.issues)
    : '';

  const summaryScore = relevance?.score ?? completeness?.score ?? accuracy?.score;

  return card({
    title: t('records.analysisPanel.contentAnalysis'),
    value: summaryScore !== undefined ? scoreSpan(summaryScore) : undefined,
    body: topicHtml + relevanceHtml + completenessHtml + accuracyHtml,
  });
};
